var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.682 11.6817V5.31778M10.4275 2.43523C11.1936 1.66913 12.419 1.44732 13.3844 2.07933C15.1899 3.2615 16.7357 4.80717 17.9178 6.61275C18.5497 7.57793 18.3276 8.80235 17.5619 9.56848L9.57685 17.5535C9.10804 18.0221 8.47215 18.2859 7.80927 18.2859H4.21118C2.83062 18.2859 1.71142 17.1664 1.71118 15.7859V12.1868C1.71128 11.5238 1.97485 10.8879 2.4436 10.4192L10.4275 2.43523ZM5.14868 13.9109C4.63091 13.9109 4.21118 14.3307 4.21118 14.8484C4.21142 15.366 4.63106 15.7859 5.14868 15.7859C5.6663 15.7859 6.08594 15.366 6.08618 14.8484C6.08618 14.3307 5.66645 13.9109 5.14868 13.9109ZM9.29549 8.49976L9.29947 8.49578L9.30345 8.49976L9.29947 8.50373L9.29549 8.49976ZM9.49437 8.30088C9.6042 8.41072 9.6042 8.58879 9.49437 8.69863C9.38453 8.80846 9.20646 8.80846 9.09662 8.69863C8.98679 8.58879 8.98679 8.41072 9.09662 8.30088C9.20646 8.19105 9.38453 8.19105 9.49437 8.30088ZM14.0685 8.49976L14.0724 8.49578L14.0764 8.49976L14.0724 8.50373L14.0685 8.49976ZM14.2673 8.30088C14.3772 8.41072 14.3772 8.58879 14.2673 8.69863C14.1575 8.80846 13.9794 8.80846 13.8696 8.69863C13.7598 8.58879 13.7598 8.41072 13.8696 8.30088C13.9794 8.19105 14.1575 8.19105 14.2673 8.30088Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.b218bebea7418af1abb0396793b80e5a.svg";
export { ForwardRef as ReactComponent };